import { MobileStepper, } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import { virtualize } from 'react-swipeable-views-utils';
import styled from 'styled-components';
import Container from '../Container';
import Typography from '../Typography';
export const CarouselStyled = styled(virtualize(SwipeableViews))(({ theme, }) => ({
// Add styles here
}));
export const StepperStyled = styled(MobileStepper)(({ theme, }) => ({
    // Add styles here
    justifyContent: 'center',
    background: 'none',
}));
export const CarouselLabel = styled(Typography).attrs(({ variant, }) => ({
    variant: variant || 'subtitle2',
}))(({ theme, }) => ({
    textAlign: 'center',
    margin: '8px 0px',
}));
export const CarouselControlsContainer = styled(Container)(({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '45px',
}));
export const CarouselContainer = styled(Container)(({
    userSelect: 'none',
}));
//# sourceMappingURL=Carousel.styles.js.map